export enum ProjectType {
    RemediationPerformanceTracker = 'remediationPerformanceTracker',
    AssetRetirement = 'assetRetirement',
}
